
/**
 * Remove Vietnamese tones from a string
 * Usage: const nameEn = removeVietnameseTones('Nguyễn Văn A'); // Returns "Nguyen Van A"
 */
export const removeVietnameseTones = (str) => {
  if (!str) return '';
  return str.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd').replace(/Đ/g, 'D');
};
